import Delta from 'quill-delta';

import { ContentTypes } from '@/constants/linkContent';
import { ISOCode } from '@/utils/currencies';
import { VisibleTo } from '@/utils/content-visibility';

export const genericInitialFields = {
  featuredImage: null,
  featuredImageThumbnail: null,
  title: '',
  isDraft: true,
  tags: [],
  bodyDelta: new Delta(),
  visibleTo: VisibleTo.EVERYONE,
  sendNotifications: false,
};

export const listDraft = {
  ...genericInitialFields,
  type: ContentTypes.LIST,
  items: [
    {
      title: null,
      upload: null,
      descriptionDelta: new Delta(),
    },
  ],
};

export const imageDraft = {
  featuredImage: null,
  title: null,
  tags: [],
  type: ContentTypes.IMAGE,
};

export const articleDraft = {
  ...genericInitialFields,
  type: ContentTypes.ARTICLE,
  rateable: false,
  isReview: false,
  reviewRating: null,
};

export const recipeDraft = {
  ...genericInitialFields,
  type: ContentTypes.RECIPE,
  servings: 0,
  cookingTime: {
    h: 0,
    m: 5,
  },
  ingredientLists: [
    {
      listTitle: null,
      ingredients: [
        { title: null },
      ],
    },
  ],
  steps: [
    { title: null, upload: null },
  ],
};

export const podcastDraft = {
  ...genericInitialFields,
  type: ContentTypes.PODCAST,
  src: null,
};

export const extrasDraft = {
  featuredImage: null,
  featuredImageThumbnail: null,
  title: null,
  isDraft: true,
  bodyDelta: new Delta(),
  type: ContentTypes.EXTRAS,
  amount: 5,
  currency: ISOCode.POUND_STERLING,
  slots: null,
  infiniteSlots: true,
  confirmationMessageDelta: new Delta(),
  isFree: true,
};

export const videoDraft = {
  ...genericInitialFields,
  type: ContentTypes.VIDEO,
  src: null,
};

export const newsLetterDraft = {
  ...genericInitialFields,
  type: ContentTypes.NEWSLETTER,
  bodyDelta: new Delta(),
};

export const drafts = {
  [ContentTypes.LIST]: listDraft,
  [ContentTypes.IMAGE]: imageDraft,
  [ContentTypes.ARTICLE]: articleDraft,
  [ContentTypes.RECIPE]: recipeDraft,
  [ContentTypes.PODCAST]: podcastDraft,
  [ContentTypes.EXTRAS]: extrasDraft,
  [ContentTypes.VIDEO]: videoDraft,
  [ContentTypes.NEWSLETTER]: newsLetterDraft,
};
